import { render } from "./Salary_Advances.vue?vue&type=template&id=1c7b9a1b"
import script from "./Salary_Advances.vue?vue&type=script&lang=js"
export * from "./Salary_Advances.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__